import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import SqlTutorial from './sqltutorial';
import SqlFormatter from './sqlformatter';
import SqlExplainer from './sqlexplainer';
import SqlOptimizer from './sqloptimizer'
import SqlDateTool from './sqldatetool';
import FreeChartBuilder from './freeChartBuilder'
import DataGenerator from './datagenerator';
import TwitterEmbed from './twitterembed';
import reportWebVitals from './reportWebVitals';
import 'core-js/stable'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/sql-tutorial" element={<SqlTutorial />} />
      <Route path="/sql-tutorial/:queryParam" element={<SqlTutorial />} />
      <Route path="/sql-formatter" element={<SqlFormatter />} />
      <Route path="/sql-explainer" element={<SqlExplainer />} />
      <Route path="/sql-optimizer" element={<SqlOptimizer />} />
      <Route path="/free-ai-chart-builder" element={<FreeChartBuilder />} />
      <Route path="/sql-date-tool" element={<SqlDateTool />} />
      <Route path="/data-generator" element={<DataGenerator />} />
      <Route path="/twitter-embed" element={<TwitterEmbed />} />
    </Routes>
  </BrowserRouter>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
